/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Title = (props) => {
    const classNames = [
        'c-type-title--3',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Title.propTypes = propTypes;

Title.defaultProps = defaultProps;

export default Title;
